import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Rajitha Rathnayaka </span>
            from <span className="purple"> Badulla.</span>
            <br />I am a graduate of Uva Wellassa University with a BSc. Hons degree in Computer Science and Technology, achieving a Second Class Lower Division . 
            He desires to learn as much as he can about technology to stay current in world events. He has worked on several Web-based projects 
            and is willing to expand his knowledge on Mobile development & backend development. He spends his leisure time listening to music, 
            watching or playing sports(mostly Taekwondo & Cricket) & capturing beautiful moments while Travelling.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Doing Taekwondo
            </li>
            <li className="about-activity">
              <ImPointRight /> Playing Cricket 
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Good Software, like wine, Takes time!"{" "}
          </p>
          <footer className="blockquote-footer">Joel Spolsky</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
